import { render, staticRenderFns } from "./AllPosts.vue?vue&type=template&id=6ca770ec&scoped=true&"
import script from "./AllPosts.vue?vue&type=script&lang=js&"
export * from "./AllPosts.vue?vue&type=script&lang=js&"
import style0 from "./AllPosts.vue?vue&type=style&index=0&id=6ca770ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca770ec",
  null
  
)

export default component.exports